import React, { useState } from 'react';

import { useParams } from 'react-router-dom';

import { api } from '@api/reduxApi';
import { Button, PopperDropdown, PopperDropdownAnchor, Text } from '@components/common';
import { WindowHeader, WindowLayout, WindowLayoutBody } from '@components/layouts/WindowLayout';
import { Basic } from '@components/shared/Skeleton';
import { Models, SurveyBuilder } from '@components/SurveyBuilder';
import { HamburgerSVG } from '@components/svgs/HamburgerSVG';
import { Tooltip } from '@components/Tooltip';
import { useFixedSidebar } from '@hooks/useSidebar';

export const UnmoderatedTestApp = () => {
  const { id } = useParams<{ id: string }>();

  const { toggle, open } = useFixedSidebar();

  const { data: study } = api.useGetStudyQuery(parseInt(id ?? ''), { skip: !id });

  const [activeBlock, setActiveBlock] = useState<Models.Block>();

  if (!id) {
    return null;
  }

  return (
    <WindowLayout>
      <WindowHeader>
        <button
          name='Toggle sidebar'
          aria-expanded={open}
          aria-label='Toggle sidebar'
          className='border-r border-gray-200 pr-4 text-gray-500 hover:text-gray-500 hover:underline'
          onClick={toggle}
        >
          <HamburgerSVG className='h-4 w-4 text-indigo-600' />
        </button>

        {study ? (
          <Text as='h2' h='700' truncate className='inline px-4 leading-9' bold>
            {study.title}
          </Text>
        ) : (
          <Basic h='8' className='ml-4 w-40' />
        )}

        <div className='ml-auto flex items-center space-x-4'>
          <PopperDropdown text='Preview' icon='eye'>
            <PopperDropdownAnchor target='_blank' href={`/studies/${id}/preview/survey`}>
              Preview from start of test
            </PopperDropdownAnchor>
            <Tooltip renderRelativeTo='parent' isDisabled={!!activeBlock} content='Cannot preview this block.'>
              <PopperDropdownAnchor
                target='_blank'
                disabled={!activeBlock}
                href={`/studies/${id}/preview/survey#${activeBlock?.token}`}
              >
                Preview from current block
              </PopperDropdownAnchor>
            </Tooltip>
          </PopperDropdown>

          <Button href={`/studies/${id}`} iconSuffix='chevronRight' primary>
            Go to Study
          </Button>
        </div>
      </WindowHeader>
      <WindowLayoutBody className='h-full'>
        <section className='px-page h-full py-4'>
          <SurveyBuilder surveyId={parseInt(id)} setActiveBlock={setActiveBlock} />
        </section>
      </WindowLayoutBody>
    </WindowLayout>
  );
};
